// extracted by mini-css-extract-plugin
export default {"container":"newService_container__HaUe9","form":"newService_form__eNpmv","footer":"newService_footer__htiN-"};